const ITEMS = [
    "Your Wish Made Real",
    "Interior Design",
    "Carpentry",
    "Painting",
    "Flooring",
    "Electrical",
    "Plumbing",
    "Kitchens",
    "Bathrooms",
    "Smart Homes",
    "Commercial",
];

const Star = () => (
    <svg viewBox="0 0 24 24" fill="#FDB927" className="h-4 w-4 shrink-0" aria-hidden="true">
        <path d="M12 1.5 14.6 9.4 22.5 12 14.6 14.6 12 22.5 9.4 14.6 1.5 12 9.4 9.4Z" />
    </svg>
);

export const Marquee = () => (
    <div className="overflow-hidden border-y border-brand-line bg-brand-surface py-6" data-testid="editorial-marquee" aria-hidden="true">
        <div className="marquee-track flex w-max items-center gap-14">
            {[...ITEMS, ...ITEMS].map((item, i) => (
                <span key={`${item}-${i}`} className="flex items-center gap-14">
                    <span
                        className={`whitespace-nowrap font-display text-2xl sm:text-3xl ${
                            i % ITEMS.length === 0 ? "italic text-brand-teal" : "text-brand-deep/70"
                        }`}
                    >
                        {item}
                    </span>
                    <Star />
                </span>
            ))}
        </div>
    </div>
);
